var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"result_modal",attrs:{"id":"result_modal","ok-title":"Close","ok-only":"","centered":""}},[_vm._v(" "+_vm._s(_vm.result)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }